"use client";

import {
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
} from "@/app/components/ui/alert-dialog";
import { Button } from "@/app/components/ui/button";
import { Input } from "@/app/components/ui/input";
import { Loader2 } from 'lucide-react';
import { Text } from "@radix-ui/themes";
import React, { useState } from "react";

interface Props {
  email: string;
  submitting: boolean;
  onClick: () => void;
}
const UnflagBidderDialog = ({
  email,
  submitting,
  onClick,
}: Props) => {
  return (
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogHeader className="font-semibold text-xl">
          Unflag {email}
        </AlertDialogHeader>
        <AlertDialogDescription>
          <Text>By unflagging this user, you allow them to begin bidding again. However, their previously removed bids will not be re-instated.
          </Text>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Cancel</AlertDialogCancel>
        <Button disabled={submitting} onClick={onClick}>
          {submitting && (
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          )}
          Unflag Bidder
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  );
};

export default UnflagBidderDialog;
